export const formatRenewalDescription = ({ email, memberTypeName }) => {
	return `MemberCenter Member Renewal: ${email}, membership type: ${memberTypeName}`;
};
